export function registerSelectors(state) {
    return state.register;
}